/**
 * KOSH SHOPIFY BRIDGE SYSTEM
 * Bridges React App events & assets with native Shopify Storefront API and Ajax Cart
 */

(function() {
  // Asset URL Resolver helper
  window.ShopifyAssetUrl = function(cleanPath) {
    if (!cleanPath) return '';
    if (cleanPath.startsWith('http://') || cleanPath.startsWith('https://') || cleanPath.startsWith('data:')) {
      return cleanPath;
    }
    const filename = cleanPath.split('/').pop();
    if (window.ShopifyAssetMap && window.ShopifyAssetMap[filename]) {
      return window.ShopifyAssetMap[filename];
    }
    if (window.ShopifyAssetBaseUrl) {
      return window.ShopifyAssetBaseUrl + filename;
    }
    return '/cdn/shop/t/1/assets/' + filename;
  };

  // Add item to Shopify Ajax Cart
  window.addKoshToShopifyCart = function(variantId, quantity, callback) {
    const qty = quantity || 1;
    if (!variantId) {
      alert("Product variant not selected or unavailable.");
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status) {
        alert("Error adding to cart: " + (data.description || data.message));
      } else {
        // Trigger cart drawer or page refresh
        if (typeof callback === 'function') callback(data);
        window.location.href = '/cart';
      }
    })
    .catch(function(err) {
      console.error("Shopify Cart Error:", err);
      window.location.href = '/cart';
    });
  };
})();
